// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__wsVmw","none":"Button_none__3A2ad","accent":"Button_accent__24bFL","red":"Button_red__3mdA9","green":"Button_green__3nIow"};